var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"grey--text",attrs:{"small":"","filter":_vm.filter,"active-class":"geoportal","outlined":_vm.active},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }